var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.websites.length > 1 && _vm.user?.type !== 'admin_delivery')?_c('div',{staticClass:"ml-2"},[_c('autocomplete',{attrs:{"items":_vm.websites,"hide-details":"","item-text":"name","item-value":"id","return-object":""},model:{value:(_vm.site),callback:function ($$v) {_vm.site=$$v},expression:"site"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }